import {
  ChatBubbleOutlineRounded,
  DarkModeOutlined,
  LightModeRounded,
  MenuRounded
} from '@mui/icons-material';
import {
  AppBar,
  Box,
  IconButton,
  Theme,
  Toolbar,
  Tooltip,
  Typography,
  alpha,
  useMediaQuery
} from '@mui/material';
import React, { useContext } from 'react';
import { Link as RRLink } from 'react-router-dom';
import { ColorModeContext } from '../..';

interface NavbarProps {
  handleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void;
}

export default function Navbar({ handleDrawer }: NavbarProps) {
  const colorMode = useContext(ColorModeContext);

  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('xs')
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={(theme) => ({
          zIndex: { xs: theme.zIndex.appBar, lg: theme.zIndex.drawer + 1 },
          bgcolor: alpha(theme.palette.background.paper, 0.7),
          color: theme.palette.text.primary,
          backdropFilter: 'blur(8px)'
        })}
      >
        <Toolbar sx={{ display: 'flex' }}>
          <Box
            sx={{
              display: { xs: 'block', lg: 'none' },
              mr: { xs: -1, sm: 1 },
              ml: { xs: 0, sm: -0.5 },
              order: { xs: 1, sm: 0 }
            }}
          >
            <Tooltip title="Menu">
              <IconButton
                size="large"
                edge={isSmallScreen ? 'end' : 'start'}
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawer(true)}
              >
                <MenuRounded />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ ml: { xs: 0.5, sm: 0 }, flexGrow: 1 }}>
            <Typography
              component={RRLink}
              to="/"
              sx={(theme) => ({
                fontSize: { xs: '1.6rem', sm: '1.9rem' },
                letterSpacing: { xs: -1.5, sm: -2 },
                fontFamily: 'Comfortaa',
                fontWeight: 700,
                cursor: 'pointer',
                color: theme.palette.text.primary,
                textDecoration: 'none'
              })}
            >
              backspace
            </Typography>
          </Box>
          <Tooltip
            title={
              colorMode.mode === 'light'
                ? 'Turn off the light'
                : 'Turn on the light'
            }
          >
            <IconButton
              onClick={() => colorMode.toggleColorMode()}
              sx={(theme) => ({ color: theme.palette.text.primary })}
            >
              {colorMode.mode === 'light' ? (
                <DarkModeOutlined />
              ) : (
                <LightModeRounded />
              )}
            </IconButton>
          </Tooltip>
          <Tooltip title="Contact backspace support">
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="contact backspace support"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_ENC_PLATFORM_SUPPORT}`,
                  '_blank'
                );
              }}
              sx={{ mr: { xs: 1, sm: -2 } }}
            >
              <ChatBubbleOutlineRounded />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
